import { kcpAPI } from '../constants';

export const getEndPoints = (productId, publisherId, externalVariantId) => ({
    productFetchURL: kcpAPI.publishers.promotion(publisherId, productId, externalVariantId),
    calculateCashback: kcpAPI.publishers.calculateCashback(publisherId, productId),
    cartItemsManageURL: kcpAPI.cart.itemsManage,
    buyNowURL: kcpAPI.cart.buyNow
});
